export function setNodeAttributes(node,nodePos,attributes) {
  var tr = window.view.state.tr
  tr.setNodeMarkup(nodePos, null, {...attributes})
  window.view.dispatch(tr)
}